import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
	providedIn: 'root'
})

export class NotificationService {
	constructor(private httpClient: HttpClient) {}
    fetchNotificationByUserId(user_id){
        return this.httpClient.get(environment.apiUrl+'/fetchNotificationByUserId?user_id=' +user_id)
    }
    readNotification(note_id){
        return this.httpClient.post(environment.apiUrl+'/readNotification',note_id);
    }
    readAllNotification(details){
        return this.httpClient.post(environment.apiUrl+'/readAllNotification',details);
    }
    fetchAllNotification(){
        return this.httpClient.get(environment.apiUrl+'/fetchAllNotification')
    }
    sendTaskNotificationToUser(details){
        return this.httpClient.post(environment.apiUrl+'/sendTaskNotificationToUser',details)
    }
}